module.exports = __webpack_public_path__ + "img/info-01-m.2f38e834.png";